module.exports = __webpack_public_path__ + "static/media/swipUp.4bfd6118.png";